import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
import { SymbolType } from "../enum/SymbolType";
/**
 * SymbolData.ts
 */
export class SymbolData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.id = this.data.getString(SlingoConstants.PROPERTY_SYMBOL);
            this.type = SymbolType.getType(this.data.getString(SlingoConstants.PROPERTY_TYPE));
        }
    }
    getId() {
        return this.id;
    }
    getType() {
        return this.type;
    }
    isNumber() {
        return this.type.isNumber();
    }
    isCoin() {
        return this.type.isCoin();
    }
    isFreeSpin() {
        return this.type.isFreeSpin();
    }
    isJoker() {
        return this.type.isJoker();
    }
    isSuperJoker() {
        return this.type.isSuperJoker();
    }
    isDevil() {
        return this.type.isDevil();
    }
    isBonus() {
        return this.type.isBonus();
    }
    isCollectable() {
        return this.type.isCollectable();
    }
    isJokerOrSuperJoker() {
        return this.isJoker() || this.isSuperJoker();
    }
}
//# sourceMappingURL=SymbolData.js.map